import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { RoleGuardService } from './core/guards/role.guard';
import { calGuard } from '@cvx/cal-angular';

export const appRoutes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'error',
        loadChildren: () =>
          import('./features/error/error.routes').then(m => m.errorRoutes)
      },
      {
        path: '',
        canActivateChild: [calGuard],
        children: [
          {
            path: '',
            canActivate: [RoleGuardService],
            loadChildren: () =>
              import('./features/home/home.routes').then(m => m.homeRoutes)
          },
          {
            path: 'home',
            canActivate: [RoleGuardService],
            loadChildren: () =>
              import('./features/home/home.routes').then(m => m.homeRoutes)
          },
          {
            path: 'assessments',
            canActivate: [RoleGuardService],
            loadChildren: () =>
              import('./features/assessment-list/assessment-list.routes').then(m => m.assessmentListRoutes)
          },
          {
            path: 'assessments/create',
            canActivate: [RoleGuardService],
            loadChildren: () =>
              import('./features/create-assessment/create-assessment.routes').then(m => m.createAssessmentRoutes)
          },
          {
            path: 'assessments/:documentId',
            canActivate: [RoleGuardService],
            loadChildren: () =>
              import('./features/create-assessment/create-assessment.routes').then(m => m.createAssessmentRoutes)
          }
        ]
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
